module.exports = {
      id: "user-square-usage",
      viewBox: "0 0 18 18",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#user-square",
      toString: function () {
        return this.url;
      }
    }